/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobLogger {
    getFixupPrototypeFunction() { return BackgroundJobLogger.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobLogger>): BackgroundJobLogger {
        let obj = Object.assign(new BackgroundJobLogger(), model);
        BackgroundJobLogger.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobLogger>): BackgroundJobLogger {
        if (!model) return null;
        return BackgroundJobLogger.newInstance(<BackgroundJobLogger> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobLogger) {
        if (!obj) return;

        models.BackgroundJobLogger.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobLogger): boolean {
        Object.setPrototypeOf(obj, BackgroundJobLogger.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Executor owning the logger
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Name of the logger
     */
    name: string;

    /**
     * Level of a Background Job Logger
     */
    level: models.BackgroundJobLoggerLevel;

    /**
     * Level of a Background Job Logger
     */
    effective_level: models.BackgroundJobLoggerLevel;

}
